import React from 'react'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { setUIState, containerIds } from 'modules/ui'
import { companyFragment, viewerFragment, userErrorsFragment } from 'fragments'
import BusinessLayout from 'components/layouts/BusinessLayout/signup'
import Join from 'components/business/Join'

function JoinContainer(props) {
  return (
    <BusinessLayout
      title={i18n.t('server.business.join.title')}
      description={i18n.t('server.business.join.description')}
      {...props}
    >
      <Join {...props} />
    </BusinessLayout>
  )
}

const verifyInvitationFromCompany = gql`
  mutation verifyInvitationFromCompany($input: VerifyInvitationFromCompanyInput!) {
    verifyInvitationFromCompany(input: $input) {
      verifiedCompanyId
      userErrors {
        ${userErrorsFragment}
      }
    }
  }
`

const withMutation = graphql(verifyInvitationFromCompany, {
  props: ({ mutate }) => ({
    verifyInvitationFromCompany: input => mutate({ variables: { input } }),
  }),
})(JoinContainer)

const withData = graphql(
  gql`
  query BusinessJoinContainer($username: String!) {
    viewer {
      ${viewerFragment}
      companies(filter: MANAGED) {
        results {
          ... on Company {
            ${companyFragment}
          }
        }
      }
    }
    company(username: $username) {
      name
      username
    }
  }
`,
  {
    options: props => ({
      notifyOnNetworkStatusChange: true,
      variables: {
        username: props.match.params.username,
      },
    }),
  },
)(withMutation)

function mapStateToProps(state) {
  return state
}

function mapDispatchToProps(dispatch) {
  const bindActions = { setUIState }
  return {
    actions: bindActionCreators(
      bindActions,
      dispatch,
      verifyInvitationFromCompany,
    ),
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withData),
)
